import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { SeatCheckbox } from "@components/table/members/assign-seats/seat-checkbox";
import { Box } from "@mui-wrapper";
import { nounPluralize } from "@utils/data-display";
/**
 * Returns why the seat cannot be given to the selection, which is only that the free seats are
 * known to be too few for it, or undefined when it can be given
 */
function getBlockReason({
  numberOfMembers,
  seatsAvailable
}) {
  if (seatsAvailable === undefined || numberOfMembers <= seatsAvailable) {
    return undefined;
  }
  return <>
      Only <var>{seatsAvailable}</var>{" "}
      {nounPluralize({
      counter: seatsAvailable,
      word: "seat",
      shouldShowCounter: false
    })}{" "}
      available. Please reduce your selection.
    </>;
}

/**
 * Checkbox to give the selected members that lack one a Sphere XG seat along with the project
 * invite, shown as the same seat card that the seats of a member are managed with: checking it
 * tells how many of the free seats the members take.
 *
 * Once the free seats are too few for the selection, the seat cannot be given to all of them, so
 * the card is shown as locked and says what to do about it instead.
 */
export function XgSeatCheckbox(t0) {
  const $ = _c(17);
  const {
    numberOfMembers,
    seatsAvailable,
    isChecked,
    isDisabled,
    description,
    onChange
  } = t0;
  let t1;
  if ($[0] !== numberOfMembers || $[1] !== seatsAvailable) {
    t1 = getBlockReason({
      numberOfMembers,
      seatsAvailable
    });
    $[0] = numberOfMembers;
    $[1] = seatsAvailable;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const blockReason = t1;
  const t2 = !blockReason;
  let t3;
  if ($[3] !== blockReason || $[4] !== t2) {
    t3 = {
      seat: "xgSeat",
      isHeld: false,
      blockReason,
      blockSeverity: "error",
      isOffered: t2
    };
    $[3] = blockReason;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const option = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mt: SPACE_ELEMENTS_OF_MODAL
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onChange) {
    t5 = (_, isNowChecked) => onChange(isNowChecked);
    $[7] = onChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== description || $[10] !== isChecked || $[11] !== isDisabled || $[12] !== numberOfMembers || $[13] !== option || $[14] !== seatsAvailable || $[15] !== t5) {
    t6 = <Box sx={t4}><SeatCheckbox option={option} isChecked={isChecked} seatsAvailable={seatsAvailable} seatsUsed={numberOfMembers} isDisabled={isDisabled} description={description} onChange={t5} /></Box>;
    $[9] = description;
    $[10] = isChecked;
    $[11] = isDisabled;
    $[12] = numberOfMembers;
    $[13] = option;
    $[14] = seatsAvailable;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}